import { computed, reactive, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { validateCompanyName, validatePersonName } from '@/lib/naming-validation';

export function useValidatedField(value, validate) {
  const { t } = useI18n();
  const blurred = ref(false);
  const submitPressed = ref(false);

  const validation = computed(() => validate(value.value, t));
  const error = computed(() => {
    if (!blurred.value && !submitPressed.value) {
      return '';
    }
    return validation.value;
  });
  const hasError = computed(() => error.value !== '');
  const isValid = computed(() => validation.value === '');

  const onBlur = () => { blurred.value = true; };
  const onSubmit = () => { submitPressed.value = true; };

  return reactive({ value, error, hasError, isValid, onBlur, onSubmit });
}

export function usePersonNameField(value) {
  return useValidatedField(value, validatePersonName);
}

export function useCompanyNameField(value) {
  return useValidatedField(value, validateCompanyName);
}
